import type { Schema } from '@cli-types/core-engine/schema.js'
import { getManyToManyFields } from '@core-engine/schema/field-helpers/flattening/get-many-to-many-fields.js'

export function schemaHasReverseManyToMany(
  targetSchema: Schema,
  currentSchemaName: string
): boolean {
  return getManyToManyFields(targetSchema.fields).some(
    (field) => field.relationship === currentSchemaName
  )
}
